import * as moment from "moment";
import { IChatThread } from "../domain";

export function parseISODate(date: string) {
  return new Date(date.slice(0, 19) + 'Z');
}

export function getThreadStatusText(thread: IChatThread, withUserName = true) {
  if (!thread) return 'Offline';
  const tUser = thread.users[0];

  const lastSeen = Number(parseISODate(tUser.lastSeen));
  var diffStr = moment.duration(Date.now() - lastSeen).humanize();

  if (isThreadOnline(thread)) return withUserName? `${tUser?.name} is online` : 'Online';
  else if (lastSeen <= 0) return withUserName? `${tUser.name} is offline` : 'Offline';
  else return (withUserName ? `${tUser.name} last `: 'Last ') + `seen ${diffStr} ago`;
}

export function isThreadOnline(thread: IChatThread) {
  if (!thread) return false;
  const tUser = thread.users[0];
  const lastSeen = Number(parseISODate(tUser.lastSeen));
  return tUser.active || (Date.now() - lastSeen) < 30 * 1000;
}